import type {ReactElement} from 'react';
import React, {useContext, useRef, useState} from 'react';
import useOutsideClick from '@Hooks/useOutsideClick';
import {EventWizardVenueSummary} from '@Components/event-wizard/event-wizard-venue-summary';
import {Text, TextSize} from '@Components/text';
import {EVENT_WIZARD_CONTAINER_QUERIES_CONTEXT} from '@Components/event-wizard/event-wizard-container-queries-context';
import {openEventWizardVenueModal} from '@Modals/event-wizard-venue-modal/event-wizard-venue-modal.types';
import {EventWizardVenueContent} from '@Components/event-wizard/event-wizard-venue-content';
import {isElementInClass} from '@Components/event-wizard/event-wizard.helper';

export function EventWizardVenue(): ReactElement<any> {
  const [isExpanded, setIsExpanded] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const {isSmallScreen} = useContext(EVENT_WIZARD_CONTAINER_QUERIES_CONTEXT);

  const toggleExpandedState = (): void => {
    if (isSmallScreen) {
      openEventWizardVenueModal();
    } else {
      setIsExpanded(!isExpanded);
    }
  };

  const toggleContainerExpand = (e: MouseEvent | PointerEvent): void => {
    const el = e.target as HTMLElement;

    if (!isElementInClass(el, 'map-selector-modal')) {
      setIsExpanded(false);
    }
  };
  useOutsideClick(containerRef, toggleContainerExpand);

  return (
    <div ref={containerRef}>
      <div className="flex-row-align-center spacing-m-b-1">
        <Text val={window.i18next.t('pmwjs_location')} size={TextSize.XXSMALL} bold />
      </div>
      <EventWizardVenueSummary isExpanded={isExpanded} toggleExpandedState={toggleExpandedState} />
      {isSmallScreen ? undefined : <EventWizardVenueContent isVisible={isExpanded} />}
    </div>
  );
}
